






















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { SeibiExtremeService } from "@/services/SeibiExtreme.service";
import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
import { Utils } from "@/services/utils";
@Component({
  components: {
    VueAutoVirtualScrollList
  }
})
export default class BuhinExtremeLink extends Vue {
  @Prop({ default: "" })
  title: string;
  seibiService: SeibiExtremeService = new SeibiExtremeService();
  util: Utils = new Utils();
  loading: boolean = false;
  loadingExtreme: boolean = false;
  listBuhin: any = [];
  listBuhinShubetsu: any = [];
  activeBuhinShubetsu = 0;
  objFilter: any = {};
  listBuhinExtremeData: any = [];
  listSelected: any = [];
  showEditDialog: boolean = false;
  showEditNameDialog: boolean = false;

  keywordFilter: string = "";
  listStaging: any = [];
  listSelectedStaging: any = [];

  customBuhinNm: string = "";
  buhinNm: string = "";
  buhinEditing: any = {};

  created() {
    this.getBuhinLink();
  }

  async getBuhinExtreme() {
    this.loadingExtreme = true;
    const { result } = await this.seibiService.getExtremeBuhin();
    this.loadingExtreme = false;
    this.loading = false;
    if (result && result.data) {
      this.$set(this, "listBuhinExtremeData", result.data);
    }
  }

  get listBuhinExtreme() {
    let list = this.listBuhinExtremeData;
    if (this.keywordFilter) {
      list = this.listBuhinExtremeData.filter(
        (e: any) =>
          e.buhinCd.indexOf(this.keywordFilter) > -1 ||
          e.buhinNm.indexOf(this.keywordFilter) > -1 ||
          e.buhinNm.toLowerCase().indexOf(this.keywordFilter.toLowerCase()) > -1
      );
    }
    if (this.listSelected.length > 0) {
      list = list.filter((item: any) => {
        return (
          this.listSelected.findIndex(
            (e: any) => e.buhinCd === item.buhinCd
          ) === -1
        );
      });
    }

    return list;
  }

  async getBuhinLink() {
    this.loading = true;
    const { result } = await this.seibiService.getBuhinLink();
    this.loading = false;
    if (result && result.data) {
      const index = result.data.length - 1;
      this.$set(this, "listBuhin", result.data[index].items);
    }
  }

  mapTree(data: any) {
    return data.map((s: any) => {
      return {
        ...s,
        isShaken: true,
        isExtreme: false,
        children: s.extremeItems.map((e: any) => {
          return { ...e, isExtreme: true };
        })
      };
    });
  }

  onFilterBunrui(buhinShubetsuCd: string, buhinBunruiCd: string) {
    let objFilter = this.objFilter[buhinShubetsuCd];
    if (objFilter == null) {
      objFilter = [];
    }
    const index = objFilter.indexOf(buhinBunruiCd);
    if (index > -1) {
      objFilter.splice(index, 1);
    } else {
      objFilter.push(buhinBunruiCd);
    }
    this.objFilter[buhinShubetsuCd] = objFilter;
    this.$forceUpdate();
  }

  isSelectBunrui(buhinShubetsuCd: string, buhinBunruiCd: string) {
    let objFilter = this.objFilter[buhinShubetsuCd];
    if (objFilter) {
      const index = objFilter.indexOf(buhinBunruiCd);
      if (index > -1) {
        return true;
      }
    }
    return false;
  }

  isDisplayBunrui(buhinShubetsuCd: string, buhinBunruiCd: string) {
    let objFilter = this.objFilter[buhinShubetsuCd];
    if (objFilter) {
      if (Object.keys(objFilter).length === 0) {
        return true;
      }
      return this.isSelectBunrui(buhinShubetsuCd, buhinBunruiCd);
    }
    return true;
  }

  onEdit(buhin: any) {
    this.showEditDialog = true;
    this.buhinEditing = buhin;
    if (this.listBuhinExtremeData.length == 0) {
      this.getBuhinExtreme();
    }
    this.listSelected = this.util.deepCopy(buhin.extremeItems);
  }

  onCloseDialog() {
    this.showEditDialog = false;
  }

  onEditName(buhin: any) {
    this.showEditNameDialog = true;
    this.buhinEditing = buhin;
    this.buhinNm = buhin.buhinNm;
    if (buhin.customBuhinNm) {
      this.customBuhinNm = buhin.customBuhinNm;
    } else if (buhin.sknCustomBuhinNm) {
      this.customBuhinNm = buhin.sknCustomBuhinNm;
    } else {
      this.customBuhinNm = "";
    }
  }

  setSelected() {
    const list = this.listBuhinExtreme.filter(
      (e: any) => this.listStaging.indexOf(e.buhinCd) > -1
    );
    this.listSelected = [...this.listSelected, ...list];
    this.listStaging = [];
  }

  removeSelected() {
    if (this.listSelectedStaging.length > 0) {
      let arrIndexDelete = this.listSelectedStaging.map((buhinCd: any) =>
        this.listSelected.findIndex((item: any) => buhinCd == item.buhinCd)
      );
      arrIndexDelete = arrIndexDelete.sort().reverse();
      arrIndexDelete.forEach((index: number) => {
        this.listSelected.splice(index, 1);
      });
      this.listSelectedStaging = [];
    }
  }

  deleteCustomName() {
    this.customBuhinNm = "";
    const obj = {
      buhinCd: this.buhinEditing.buhinCd,
      customBuhinNm: this.customBuhinNm
    };
    this.seibiService
      .deleteBuhinName(obj, this.buhinEditing.isExtreme)
      .then(res => {
        this.onAfterSave(res);
      });
  }

  saveCustomName() {
    let obj: any = {
      customBuhinNm: this.customBuhinNm
    };
    if (this.buhinEditing.isExtreme) {
      obj.buhinCd = this.buhinEditing.buhinCd;
    } else {
      obj.shakenBuhinId = this.buhinEditing.buhinId;
    }
    this.seibiService
      .saveBuhinName(obj, this.buhinEditing.isExtreme)
      .then(res => {
        this.onAfterSave(res);
      });
    this.showEditNameDialog = false;
  }

  onAfterSave(res: number) {
    if (res == 200) {
      this.getBuhinLink();
    } else {
      this.$message("エラー");
    }
  }

  saveBuhinLink() {
    let obj: any = { shakenBuhinId: this.buhinEditing.buhinId };
    let listBuhinCd = this.listSelected.map((e: any) => e.buhinCd);
    let extremeBuhins: any = [];
    let deletedExtremeBuhins: any = [];
    let arrPromise: any = [];
    if (this.buhinEditing.extremeItems.length > 0) {
      deletedExtremeBuhins = this.buhinEditing.extremeItems
        .filter((extreme: any) => listBuhinCd.indexOf(extreme.buhinCd) === -1)
        .map((e: any) => {
          return { buhinCd: e.buhinCd };
        });
    }
    if (this.listSelected.length > 0) {
      extremeBuhins = this.listSelected.map((e: any) => {
        return { buhinCd: e.buhinCd };
      });
      obj = { ...obj, deletedExtremeBuhins, extremeBuhins };
      arrPromise.push(this.seibiService.saveExtremeBuhinLink(obj));
    }
    if (deletedExtremeBuhins.length > 0) {
      obj = { ...obj, deletedExtremeBuhins, extremeBuhins };
      arrPromise.push(this.seibiService.deleteExtremeBuhinLink(obj));
    }

    Promise.all(arrPromise).then((res: any) => {
      console.log(res);
      let isError = res.every((e: number) => e != 200);
      if (isError) {
        this.$message.error("エラー");
      }
      this.getBuhinLink();
    });
    this.showEditDialog = false;
  }
}
